import styled from 'styled-components';
import { COLOR } from '@src/styles/color';

export const StyledConfigMultiBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  height: 32px;

  .config-multi-block-voice {
    display: flex;
    align-items: center;
  }

  .checkbox-container {
    padding: 4px 8px 4px 0px;
    margin-left: 0px;
  }
  .MuiFormControlLabel-root {
    margin-right: 0px;
  }
  .checkbox-label {
    color: ${COLOR.indigo.default};

    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
    letter-spacing: -0.4px;
  }
  .checkbox-color {
    color: ${COLOR.indigo.default};
  }
  .choose-voice {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    text-transform: capitalize;
    padding: 4px 6px;
    border-radius: 16px;

    &:hover,
    &:focus {
      background: ${COLOR.secondary[80]};
    }
  }
  .editor-toolbar-btn {
    height: 32px;
    width: 32px;
    .editor-toolbar-btn-icon {
      color: ${COLOR.indigo[80]};
    }
  }
  .disabled-btn {
    cursor: not-allowed;
    opacity: 0.32;
  }
  .returning-error-icon {
    color: ${COLOR.redPrimary};
    font-size: 14px;
    cursor: pointer;
  }
`;
